type AppInsightsLike = {
  trackException: (telemetry: { exception: Error, properties?: Record<string, string> }) => void
};

declare global {
  interface Window {
    appInsights?: AppInsightsLike
  }
}

/**
 * SPA 側の例外を Application Insights (/ai.js) へ送信する。
 * appInsights 未ロード時・送信失敗時のみ console.error にフォールバックする。
 */
export const trackClientException = (
  error: Error,
  properties?: Record<string, string>
): void => {
  let sent = false;
  try {
    if (window.appInsights?.trackException) {
      window.appInsights.trackException({ exception: error, properties });
      sent = true;
    }
  }
  catch {
    sent = false;
  }
  if (!sent) {
    // eslint-disable-next-line no-console -- telemetry 未初期化 / 送信失敗時の開発可視性
    console.error(error.message, properties);
  }
};
